module.exports = __webpack_public_path__ + "img/logo.a20a2476.png";